
  import { ref } from 'vue';
  import { Options, Vue } from 'vue-class-component';
  import { FilterMatchMode } from 'primevue/api';
  import { ReportsModule, ReportsStore, ErrorLogEntry } from '@/store/reports';
  import moment from 'moment';

  @Options({})
  export default class ErrorsLog extends Vue {
    private reportsStore: ReportsModule = ReportsStore;

    items: ErrorLogEntry[] = [];
    expandedRows = [];
    loading = false;
    globalFilter = ['controller', 'type', 'message', 'originAccount'];

    filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    formatDate(date: string) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss') : '';
    }

    async mounted() {
      this.loading = true;
      this.items = await this.reportsStore.getErrorsLog();
      this.loading = false;
    }
  }
